import { BRAZIL_DRIVER_RECRUITMENT, BRAZIL_DRIVER_SIGNUP_FORM, BRAZIL_OPERATOR_ENTITY, BRAZIL_PHONE_DISPLAY, COUNTRY_BR_VOCABULARIES } from '@vello/country-br';
import { resolveDriverRecruitment } from '@vello/config';
import { CATALOG, indexVocabularies } from '@vello/vocabulary';
/**
 * D577 (ADR-0105): the shared catalog plus every installed country pack's own vocabularies — the one index a console reads.
 * The shared catalog stays country-neutral; a code that exists only in one pack (a national document, a local payment
 * capability) is declared by that pack and joins here. Adding a country pack = adding its list below.
 */
export const COUNTRY_VOCABULARIES = [...COUNTRY_BR_VOCABULARIES];
export const VOCABULARY = indexVocabularies([...CATALOG, ...COUNTRY_VOCABULARIES]);
/**
 * D580: how every installed country pack writes a phone number — the rules `formatPhone` (`@vello/format`) reads. The
 * display pattern is a country-pack fact; this list is the one place a console looks them up. Adding a country pack =
 * adding its `PhoneDisplayRule` below (an uninstalled country falls back to `+CC rest`).
 */
export const PHONE_DISPLAY_RULES = [BRAZIL_PHONE_DISPLAY];
/**
 * D719 (doc 29 G14): the company that runs Vello in each installed country, as the apps' "Sobre" names it. A country pack holds the facts; adding a country
 * pack = adding its entity below (an uninstalled country names none - never a guess).
 */
export const OPERATOR_ENTITIES = [BRAZIL_OPERATOR_ENTITY];
/**
 * D724 (doc 29 G13): the "Seja motorista" content of each installed country (`@vello/config` `DriverRecruitmentContent`). A country pack holds it; adding a
 * country pack = adding its content below (an uninstalled country recruits nowhere - the rider app hides the entry).
 */
export const DRIVER_RECRUITMENT_CONTENTS = [BRAZIL_DRIVER_RECRUITMENT];
/** What a market reads at `at` over the installed packs (the market's own members win over its country's; no content = not offered). */
export function driverRecruitmentFor(marketId, at, contents = DRIVER_RECRUITMENT_CONTENTS) {
    return resolveDriverRecruitment(contents, marketId, at);
}
/**
 * D753 (the D751 program, doc 34 K8): how each installed country pack words and checks the provider app's "Seus dados" step - the full name labelled by the
 * document it must match, and the national id the sign-up API asks typed in the country's pattern and checked by its digits. Adding a country pack = adding
 * its form below (an uninstalled country gets the app's neutral words; the server still checks the number).
 */
export const DRIVER_SIGNUP_FORMS = [BRAZIL_DRIVER_SIGNUP_FORM];
/** The installed form of a country (undefined = none). */
export function driverSignupFormFor(countryCode, forms = DRIVER_SIGNUP_FORMS) {
    if (countryCode === undefined)
        return undefined;
    const cc = countryCode.trim().toUpperCase();
    return forms.find((f) => f.countryCode.toUpperCase() === cc);
}
/** The typing rules a country's form gives the national id type the sign-up API asks (undefined = none: the field takes the text as typed). */
export function driverSignupNationalIdInput(form, type) {
    if (form === undefined || type === undefined)
        return undefined;
    return form.nationalIds.find((n) => n.type === type);
}
//# sourceMappingURL=index.js.map